import React, { ComponentType } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'

const Null = () => null

const withAppBoot =
  <T,>(
    Component: ComponentType<T>,
    Placeholder: ComponentType = Null,
    ErrorFallback: ComponentType<{ error: Error }> = Null
  ): ComponentType<T> | ComponentType =>
  (props: T) => {
    const { appReady, appError } = useSelector((state: AppState) => state.user)

    if (appError) return <ErrorFallback error={appError} />

    if (!appReady) return <Placeholder />
    /*@ts-ignore */
    return <Component {...props} />
  }

export default withAppBoot
